
import React from 'react';

const GuideImg: React.ComponentType<React.SVGProps<SVGSVGElement>> = (props) => (
<svg width="147" height="146" viewBox="0 0 147 146" fill="none" xmlns="http://www.w3.org/2000/svg">
<g id="Group 1000">
<g id="Group 999">
<ellipse id="Ellipse 2" cx="72.5782" cy="72.6034" rx="72.2108" ry="72.6034" fill="#EAF1FF"/>
<g id="Mask group">
<mask id="mask0_4366_3351" maskUnits="userSpaceOnUse" x="1" y="0" width="146" height="146">
<ellipse id="Ellipse 2_2" cx="74.1566" cy="73.3968" rx="72.2108" ry="72.6034" fill="white"/>
</mask>
<g mask="url(#mask0_4366_3351)">
<g id="Group 998">
<rect id="Rectangle 2766" x="24.2242" y="38.6476" width="96.7675" height="131.212" rx="22.609" fill="#F9F9F9" stroke="#1B1D29" strokeWidth="6.7346"/>
<g id="Rectangle 2767" filter="url(#filter0_d_4366_3351)">
<rect x="10.6268" y="63.1113" width="124.564" height="32.0665" rx="9.62085" fill="white"/>
</g>
<rect id="Rectangle 2768" x="17.8481" y="68.5566" width="20.4597" height="20.571" rx="9.62085" fill="#DEDEE3"/>
<rect id="Rectangle 2769" x="44.3252" y="70.9766" width="71.609" height="5.44525" rx="2.72263" fill="#DEDEE3"/>
<rect id="Rectangle 2770" x="44.3252" y="81.8677" width="54.1581" height="5.44525" rx="2.72263" fill="#DEDEE3"/>
<rect id="Rectangle 2771" x="60.5726" y="46.1709" width="24.672" height="4.84022" fill="#1A1C28"/>
</g>
</g>
</g>
</g>
</g>
<defs>
<filter id="filter0_d_4366_3351" x="-1.88028" y="50.6042" width="149.578" height="57.0806" filterUnits="userSpaceOnUse" colorInterpolationFilters="sRGB">
<feFlood floodOpacity="0" result="BackgroundImageFix"/>
<feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
<feOffset/>
<feGaussianBlur stdDeviation="6.25355"/>
<feComposite in2="hardAlpha" operator="out"/>
<feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0"/>
<feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_4366_3351"/>
<feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_4366_3351" result="shape"/>
</filter>
</defs>
</svg>
);

export default GuideImg;